import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import httpInjectorService from 'services/http-injector.service';
import { ThunderboltOutlined } from '@ant-design/icons';
import SubtaskObject from '@atlaskit/object/subtask';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import { toast } from 'react-toastify';

const LinkWorkItemInput = ({
  onCancel,
  current_item_type,
  current_item_id,
  onSuccess
}) => {
 
 
  const [linkTypes, setLinkTypes] = useState([]); 
  const [linkType, setLinkType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [selectedWorkItems, setSelectedWorkItems] = useState([]);
  const [workitems, setWorkItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const selectedLinkType = linkType ? JSON.parse(linkType) : null;

  const workItemList = [
    'is blocked by',
    'blocks',
    'relates to',
    'duplicate of',
    'child of',
  ];

  const fetchAllData = async () => {
    const reqbody = {
      current_item_type: current_item_type,
      current_item_id: current_item_id,
    };
    try {
      const response = await httpInjectorService.listOfWorkItemstoLink(reqbody);
      if (response.status === 'success') {
        setWorkItems(response.data);
      } else {
        setWorkItems([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const filterOption = (option, inputValue) => {
  const search = inputValue.toLowerCase();

  return (
    option.data.label.toLowerCase().includes(search) ||
    option.data.key.toLowerCase().includes(search)
  );
};

  const fetchWorkItems = async () => {
    try {
      setLoading(true);

      const res = await httpInjectorService.listLinkTypes();
      const apiData = res?.data || [];

    

      const types = apiData.flatMap((item) => [
        {
          id: item.id,
          label: item.outward_label,
          direction: 'outward',
        },
        {
          id: item.id,
          label: item.inward_label,
          direction: 'inward',
        },
      ]);

    

      setLinkTypes(types); // store dropdown options
    } catch (error) {
      console.error('Error fetching work items:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchWorkItems();
    fetchAllData();
  }, []);

  const getIcon = (item) => {
    if (item.item_type === 'epic') {
      return <ThunderboltOutlined style={{ color: '#6554C0', fontSize: 16 }} />;
    }

    if (item.item_type === 'subtask') {
      return <SubtaskObject />;
    }

    if (item.issue_type_id === 1) {
      return <TaskObject />;
    }

    if (item.issue_type_id === 2) {
      return <StoryObject />;
    }

    if (item.issue_type_id === 3) {
      return <BugObject />;
    }

    return null;
  };

  const options = workitems?.map((item) => ({
    value: item.item_id,
    label: item.title,
    key: item.epic_key,
    item_type: item.item_type,
    icon: getIcon(item),
  }));

  const formatOptionLabel = ({ label, key, icon }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {icon}
      <span>
        {key} - {label}
      </span>
    </div>
  );
 
  const LinkWOrkItems = async () => {
   
    if (!selectedWorkItems.length || !selectedLinkType) return;

    const links = selectedWorkItems.map((item) => {
      if (selectedLinkType.direction === 'outward') {
        return {
          source_item_type: current_item_type,
          source_item_id: current_item_id,
          target_item_type: item.item_type,
          target_item_id: item.value,
          link_type_id: selectedLinkType.id,
        };
      } else {
        return {
          source_item_type: item.item_type,
          source_item_id: item.value,
          target_item_type: current_item_type,
          target_item_id: current_item_id,
          link_type_id: selectedLinkType.id,
        };
      }
    });
   

    const reqbody = { links };

   

    try {
      const response = await httpInjectorService.LinkWorkItems(reqbody);

      if (response.status === 'success') {
        toast.success(response.message, { autoClose: 3000 });
       onCancel();
       onSuccess && onSuccess();
       
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAdd = () => {
   
    LinkWOrkItems();
   
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div
      style={{
        // border: "1px solid #ddd",
        padding: '2px',
        // background: "#f5f5f5",
        width: '750px',
        fontFamily: 'Segoe UI, sans-serif',
      }}
    >
      {/* TOP ROW */}
     <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
        {/* Dropdown */}
        <select
  value={linkType}
  onChange={(e) => setLinkType(e.target.value)}
  style={{
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '3px',
    minWidth: '180px',
    background: 'white',
  }}
>
  {/* ✅ Placeholder */}
  <option value="" disabled>
    Select link type
  </option>

  {linkTypes.map((type, index) => (
    <option key={`${type.id}-${index}`} value={JSON.stringify(type)}>
      {type.label}
    </option>
  ))}
</select>

        <div style={{ width: '500px' }}>
          <Select
            isMulti
            isClearable
            placeholder="Search for work items, or paste link"
            value={selectedWorkItems}
            closeMenuOnSelect={false}
            options={options}
            formatOptionLabel={formatOptionLabel}
            filterOption={filterOption}
            onChange={(newValue) => {
              setSelectedWorkItems(newValue || []);
            }}
          />
        </div>
      </div>

      {/* BOTTOM ROW */}

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          paddingRight: '40px', // move content to right
          marginTop: '10px',
          alignItems: 'center',
        }}
      >
        {/* Buttons */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={handleAdd}
            disabled={!selectedWorkItems.length || !selectedLinkType}
            style={{
              padding: '6px 14px',
              background: selectedWorkItems.length ? '#0078d4' : '#e0e0e0',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: selectedWorkItems.length ? 'pointer' : 'not-allowed',
            }}
          >
            Add
          </button>

          <button
            onClick={handleCancel}
            style={{
              padding: '6px 14px',
              background: 'transparent',
              border: '1px solid #ccc',
              borderRadius: '3px',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkWorkItemInput;
